<template>
    <v-card style="height: calc(100vh - 64px); overflow-y: hidden; display: flex; flex-direction: column;">
        <v-card-title>担当一覧</v-card-title>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex v-if="isSearching()">
                    <v-btn class="primary mr-2" @click="openDialog">検索</v-btn>
                    <v-btn class="error mr-2" @click="resetSearch">検索リセット</v-btn>
                </v-flex>
                <v-flex v-else>
                    <v-btn @click="openDialog">検索</v-btn>
                </v-flex>
                <v-flex class="text-right" v-if="canCreate()">
                    <v-btn class="info" to="/customer/add">新規登録</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-text style="display: flex; flex-direction: column; flex: 1; overflow-y: hidden;">
            <v-data-table
                :headers="headers"
                :items="customers"
                :loading="loading"
                hide-default-footer
                :items-per-page="conditions.perPage"
                class="elevation-1"
                style="flex: 1; overflow-y: hidden;"                
            >
                <template v-slot:[`item.course`]="{ item }">
                    {{ showCourse(item.course) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    {{ showStatus(item.status) }}
                </template>
                <template v-slot:[`item.address`]="{ item }">
                    {{ showPrefecture(item.pref) }}{{ item.address }}
                </template>
                <template v-slot:[`item.age`]="{ item }">
                    {{calcAge(item.birthday)}}歳
                </template>
                <template v-slot:[`item.gender`]="{ item }">
                    {{CUSTOMER.GENDER.getName(item.gender)}}
                </template>
                <template v-slot:[`item.front`]="{ item }">
                    <v-select
                        v-model="item.front_id"
                        :items="frontOptions"
                        dense
                        hide-details
                        @change="updateFront(item.id, item.front_id)"
                        :loading="item.frontUpdating"
                        :disabled="!canUpdateResponsibility"
                    >
                        <template v-slot:selection="{ item: selectedItem }">
                            {{ selectedItem.text || item.front_name || '未定' }}
                        </template>
                    </v-select>
                </template>
                <template v-slot:[`item.closer`]="{ item }">
                    <v-select
                        v-model="item.counselor_id"
                        :items="counselorOptions"
                        dense
                        hide-details
                        @change="updateCounselor(item.id, item.counselor_id)"
                        :loading="item.counselorUpdating"
                        :disabled="!canUpdateResponsibility"
                    >
                        <template v-slot:selection="{ item: selectedItem }">
                            {{ selectedItem.text || item.counselor_name || '未定' }}
                        </template>
                    </v-select>
                </template>
            </v-data-table>
            <v-pagination
                v-model="currentPage"
                :length="total"
                @input="reloadList"
            ></v-pagination>
        </v-card-text>

            <v-dialog v-model="searchDialog" persistent max-width="800px">
                <v-form>
                    <v-card>
                        <v-card-title>
                            <span class="headline">会員検索</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md3 v-if="canSearchAll()">
                                        <v-select
                                            v-model="conditions.shop_id"
                                            :items="searchShops"
                                            label="支店"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.front_id"
                                            :items="searchFronts"
                                            label="フロント"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.counselor_id"
                                            :items="searchCounselors"
                                            label="クローザー"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.phone_number"
                                            label="電話番号"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.name"
                                            label="名前"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.gender"
                                            :items="searchGenders"
                                            label="性別"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.status"
                                            :items="searchStatus"
                                            label="状態"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-checkbox
                                            v-model="conditions.is_exit"
                                            label="退会済会員"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs0 sm0 md6></v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.perPage"
                                            :items="perPages"
                                            label="件数"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="info"
                                @click="search"
                                >検索</v-btn
                            >
                            <v-btn @click="closeDialog">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="deleteDialog" persistent max-width="290px">
                <v-card>
                    <v-card-title> 削除しますか？ </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark class="delete" @click="deleteCustomer"
                            >削除</v-btn
                        >
                        <v-btn @click="deleteClose">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    </v-card>
</template>

<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"

export default {
    title: "担当一覧",
    name: "customer_list",
    mixins: [utilDatetime],
    data: () => ({
        CUSTOMER: CUSTOMER,
        customers: [],
        loading: true,
        headers: [
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "住所", value: "address", align: "start", sortable: false },
            { text: "年齢", value: "age", align: "start", sortable: false },
            { text: "性別", value: "gender", align: "start", sortable: false },
            { text: "コース", value: "course", align: "start", sortable: false },
            { text: "状態", value: "status", align: "start", sortable: false },
            { text: "フロント", value: "front", align: "start", sortable: false, width: "220px" },
            { text: "クローザー", value: "closer", align: "start", sortable: false, width: "220px" },
        ],
        currentPage: 1,
        perPage: 50,
        total: null,
        prefectures: [],
        shops: [],
        conditions: {
            shop_id: 0,
            front_id: 0,
            counselor_id: 0,
            phone_number: "",
            name: "",
            gender: 0,
            status: 0,
            is_exit: false,
            perPage: 50,
        },
        searchDialog: false,
        searchShops: [],
        searchFronts: [],
        searchCounselors: [],
        searchGenders: [],
        frontOptions: [],
        counselorOptions: [],
        searchStatus: [
            { value: 0, text: "全て" },
            { value: 1, text: "シフト対象者" },
            { value: 2, text: "退会予備状態" },
            { value: 3, text: "退会処理待ち" },
            { value: 4, text: "休止会員" },
        ],
        perPages: [
            { value: 50, text: "50件" },
            { value: 100, text: "100件" },
            { value: 200, text: "200件" },
        ],
        deleteDialog: false,
        deleteTargetId: 0,
    }),
    computed: {
        canUpdateResponsibility() {
            const self = this.$store.state.user;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.UPDATE_RESPONSIBLE) return true;
            return false;
        },
    },
    async mounted() {
        // 検索条件の読み込み
        this.loadSearchConditions();

        this.currentPage = parseInt(this.$route.query.page || 1);
        await this.loadList();
    },
    async beforeRouteUpdate(to, from, next) {
        this.currentPage = parseInt(to.query.page || 1);
        await this.loadList();
        next();
    },
    methods: {
        async reloadList() {
            const url = `/customer/staff?page=${this.currentPage}`;
            this.$router.push(url);
            scrollTo(0, 0);
        },
        async loadList() {
            this.loading = true;
            try {
                const result = await this.$axios
                    .get("/api/v1/customer", {
                        params: {
                            page: this.currentPage,
                            perPage: this.conditions.perPage,
                            shop_id: this.conditions.shop_id,
                            front_id: this.conditions.front_id,
                            counselor_id: this.conditions.counselor_id,
                            phone_number: this.conditions.phone_number,
                            name: this.conditions.name,
                            gender: this.conditions.gender,
                            status: this.conditions.status,
                            is_exit: this.conditions.is_exit,
                        }
                    })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((error) => {
                        return error;
                    });

                if (result) {
                    // Add front_id and counselor_id to each customer item, and add loading states
                    this.customers = result.customers.map(customer => ({
                        ...customer,
                        front_id: customer.front_id,
                        counselor_id: customer.counselor_id,
                        frontUpdating: false,
                        counselorUpdating: false
                    }));
                    this.total = result.total;
                    this.shops = result.shops;
                    this.prefectures = result.prefectures;

                    this.searchShops = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.shops.forEach(shop => this.searchShops.push({ value: shop.id, text: shop.name}));
                    this.searchFronts = [{
                        value: 0,
                        text: "全て"
                    }];
                    (result.fronts || result.counselors).forEach(f => this.searchFronts.push(f));
                    this.searchFronts.push({ value: -1, text: "未定" });
                    this.searchCounselors = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.counselors.forEach(c => this.searchCounselors.push(c));
                    
                    this.searchCounselors.push({ value: -1, text: "未定" });
                    this.searchGenders = [{
                        value: 0,
                        text: "全て"
                    }];
                    CUSTOMER.GENDER.LIST.forEach(g => this.searchGenders.push(g));

                    // Set up select box options for the table
                    this.frontOptions = [
                        { value: null, text: "未定" },
                        ...(result.fronts || result.counselors).filter((f) => f.valid).map(f => ({ value: f.value, text: f.text })),
                    ];
                    this.counselorOptions = [
                        { value: 0, text: "未定" },
                        ...result.counselors.filter((f) => f.valid).map(c => ({ value: c.value, text: c.text })),
                    ];
                }
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },
        showShopName(shopId) {
            const shop = this.shops.find(shop => shop.id == shopId);
            if(!shop) return '';
            return shop.name;
        },
        showCourse(course) {
            if(!course) return '未契約';
            return `${course.name}(${course.contract_date}～)`
        },
        showStatus(status) {
            const statusStr = ['活動中', '退会予備状態', '休止状態', '退会処理待ち'];
            if(status < 0 || statusStr.length <= status) return '';
            return statusStr[status];
        },
        showPrefecture(pref) {
            const prefecture = this.prefectures.find(prefecture => prefecture.id == pref);
            if(!prefecture) return '';
            return prefecture.name;
        },
        loadSearchConditions() {
            this.conditions = Object.assign({}, this.$store.state.staffConditions);
        },
        isSearching() {
            if(this.$store.state.staffConditions.shop_id != 0) return true;
            if(this.$store.state.staffConditions.front_id != 0) return true;
            if(this.$store.state.staffConditions.counselor_id != 0) return true;
            if(this.$store.state.staffConditions.phone_number && this.$store.state.staffConditions.phone_number.length > 0) return true;
            if(this.$store.state.staffConditions.name && this.$store.state.staffConditions.name.length > 0) return true;
            if(this.$store.state.staffConditions.gender != 0) return true;
            if(this.$store.state.staffConditions.status != 0) return true;
            if(this.$store.state.staffConditions.is_exit) return true;
            return false;
        },
        search() {
            this.$store.dispatch("setCustomerStaffSearchConditions", this.conditions);
            this.closeDialog();
            this.currentPage = 1;
            const isAlreadyOnFirstPage =
                this.$route.path === "/customer/staff" && parseInt(this.$route.query.page || 1) === 1;
            if (isAlreadyOnFirstPage) {
                this.loadList();
                scrollTo(0, 0);
            } else {
                this.$router.push({ path: "/customer/staff", query: { page: 1 } });
            }
        },
        resetSearch() {
            this.conditions = {
                shop_id: 0,
                front_id: 0,
                counselor_id: 0,
                phone_number: "",
                name: "",
                gender: 0,
                status: 0,
                is_exit: false,
                perPage: 50,
            };
            this.search();
        },
        async openDialog() {
            this.loadSearchConditions();
            // Load search data if not already loaded
            if (this.searchFronts.length <= 1) {
                await this.loadSearchData();
            }
            this.searchDialog = true;
        },
        closeDialog() {
            this.searchDialog = false;
        },
        async loadSearchData() {
            try {
                const result = await this.$axios
                    .get("/api/v1/customer", {
                        params: {
                            page: 1,
                            perPage: 1
                        }
                    })
                    .then((response) => {
                        return response.data;
                    });

                if (result) {
                    this.searchShops = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.shops.forEach(shop => this.searchShops.push({ value: shop.id, text: shop.name}));
                    this.searchFronts = [{
                        value: 0,
                        text: "全て"
                    }];
                    (result.fronts || result.counselors).forEach(f => this.searchFronts.push(f));
                    this.searchFronts.push({ value: -1, text: "未定" });
                    this.searchCounselors = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.counselors.forEach(c => this.searchCounselors.push(c));
                    this.searchCounselors.push({ value: -1, text: "未定" });
                }
            } catch (error) {
                console.log("Error loading search data: " + error);
            }
        },
        canCreate() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_CREATE) return true;
            return false;
        },
        canSearchAll() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_ALL) return true;
            return false;
        },
        deleteConfirm(id) {
            this.deleteTargetId = id;
            this.deleteDialog = true;
        },
        async updateFront(customerId, frontId) {
            const customer = this.customers.find(c => c.id === customerId);
            if (!customer) return;

            const originalValue = customer.front_id;
            customer.frontUpdating = true;
            try {
                await this.$axios.put(`/api/v1/customer/${customerId}/front`, { front_id: frontId });
                // Update the local data
                customer.front_id = frontId;
            } catch (error) {
                console.log("Error updating front: " + error);
                // Revert the change on error
                customer.front_id = originalValue;
            } finally {
                customer.frontUpdating = false;
            }
        },
        async updateCounselor(customerId, counselorId) {
            const customer = this.customers.find(c => c.id === customerId);
            if (!customer) return;

            const originalValue = customer.counselor_id;
            customer.counselorUpdating = true;
            try {
                await this.$axios.put(`/api/v1/customer/${customerId}/counselor`, { counselor_id: counselorId });
                // Update the local data
                customer.counselor_id = counselorId;
            } catch (error) {
                console.log("Error updating counselor: " + error);
                // Revert the change on error
                customer.counselor_id = originalValue;
            } finally {
                customer.counselorUpdating = false;
            }
        },
    },
};
</script>
<style scoped lang="css">
::v-deep .v-select__selections {
  font-size: 14px !important;
}
::v-deep .v-data-table__wrapper {
  width: 100% !important;
  height: 100% !important;
  overflow-y: auto !important;
  position: relative;
}

::v-deep .v-data-table__wrapper table {
  min-width: max-content !important;
}

::v-deep .v-data-table-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
}
</style>
